<template>
  <div class="animated fadeIn">
    <div id="Dashboard">
      <b-card>
        <b-card-header style="height: 15rem">
          <b-row>
            <b-col md="2"> <i class="icon-chart"></i>Tabela finansów </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="2">
              <label class="mr-sm-2">Data: </label>
              <v-date-picker
                class="date-picker"
                @input="setDateRange"
                mode="range"
                v-model="datePicker"
                is-double-paned
                is-inlines
              >
              </v-date-picker>
            </b-col>
            <b-col md="2">
              <label class="mr-sm-2">Etykiety: </label>
              <multiselect
                @input="refreshTable"
                deselect-label=""
                select-label=""
                placeholder="Wybierz wartośc filtru"
                track-by="_id"
                :options="labels"
                label="name"
                :multiple="true"
                v-model="options.params.filters.label"
              ></multiselect>
            </b-col>
            <b-col md="2">
              <label class="mr-sm-2">Nie zawiera etykiety</label>
              <multiselect
                @input="refreshTable"
                deselect-label=""
                select-label=""
                placeholder="Wybierz wartośc filtru"
                track-by="_id"
                :options="labels"
                label="name"
                :multiple="true"
                v-model="options.params.filters.excludeLabel"
              ></multiselect>
            </b-col>
            <b-col md="2">
              <label class="mr-sm-2">Przychód/Obciązenie: </label>
              <multiselect
                @input="refreshTable"
                deselect-label=""
                select-label=""
                placeholder="Wybierz wartośc filtru"
                :options="['Przychód', 'Obciążenie']"
                :multiple="true"
                v-model="options.params.filters.chargeIncome"
              ></multiselect>
            </b-col>
            <b-col md="2">
              <label class="mr-sm-2">Zawiera etykietę</label>
              <multiselect
                @input="refreshTable"
                deselect-label=""
                select-label=""
                placeholder="Wybierz wartośc filtru"
                :options="['Tak', 'Nie']"
                :multiple="true"
                v-model="options.params.filters.containLabel"
              ></multiselect>
            </b-col>
            <b-col md="2">
              <label class="mr-sm-2">Zawiera fakturę</label>
              <multiselect
                @input="refreshTable"
                deselect-label=""
                select-label=""
                placeholder="Wybierz wartośc filtru"
                :options="['Tak', 'Nie']"
                :multiple="true"
                v-model="options.params.filters.containInvoice"
              ></multiselect>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="2">
              <label class="mr-sm-2">Zawiera komentarz</label>
              <multiselect
                @input="refreshTable"
                deselect-label=""
                select-label=""
                placeholder="Wybierz wartośc filtru"
                :options="['Tak', 'Nie']"
                :multiple="true"
                v-model="options.params.filters.containComment"
              ></multiselect>
            </b-col>
            <b-col :offset-md="2" md="2">
              <label class="mr-sm-2">Zapisz ustawienia filtrów</label>
              <br />
              <b-button @click="savePresetModal = true" variant="primary"
                >Zapisz ustawienia
                <i class="fa fa-save"></i>
              </b-button>
            </b-col>
            <b-col md="2">
              <label for="presets">Pobierz zestawienie</label>
              <br />
              <b-button
                v-b-tooltip.hover
                title="Spakowane zestawienie wszystkich dokumentów z wybranego zakresu"
                @click="openDownloadZipModal"
                variant="primary"
                >Pobierz zestawienie
                <i class="cui-cloud-download icons"></i>
              </b-button>
            </b-col>
            <b-col md="2">
              <label for="presets">Pobierz jako csv</label>
              <br />
              <b-button @click="saveAsCsv" variant="primary"
                >Pobierz csv
                <i class="fa fa-file-excel-o"></i>
              </b-button>
            </b-col>
            <b-col md="2">
              <label for="presets">Konfiguracje</label>
              <multiselect
                @input="setPreset"
                track-by="_id"
                label="name"
                deselect-label=""
                select-label=""
                placeholder="Wybierz preset"
                :options="presets"
                v-model="preset"
              ></multiselect>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <v-server-table
            id="dataTable"
            ref="documentTable"
            :url="apiUrl"
            :columns="columns"
            :options="options"
          >
            <div slot="invoice" slot-scope="props">
              <i
                style="color: green"
                v-if="props.row.invoice.length"
                class="fa fa-check"
              ></i>
              <i v-else-if="props.row.neverContainInvoice" class="fa fa-check">
                bez dokumentu</i
              >
              <i v-else class="fa fa-remove"></i>
            </div>
            <div slot="operation_date" slot-scope="props">
              {{ props.row.operation_date.substring(0, 10) }}
            </div>
            <div slot="accounting_date" slot-scope="props">
              {{ props.row.accounting_date.substring(0, 10) }}
            </div>
            <div slot="labels" slot-scope="props">
              <b-badge
                v-b-tooltip.hover
                :title="label.scope"
                v-for="(label, index) in props.row.labels"
                :key="index"
                :style="{ 'background-color': label.color }"
                variant="primary"
                >{{ label.name }}</b-badge
              >
            </div>
            <div slot="actions" slot-scope="props">
              <b-button
                id="updateRow"
                @click="openEditModal(props.row)"
                size="sm"
                variant="primary"
              >
                <i class="fa fa-edit"></i>
              </b-button>
              <b-tooltip
                :target="'updateRow-' + props.row._id"
                title="Edytuj pozycję"
              ></b-tooltip>

              <b-button
                style="margin-left: 5px"
                id="deleteRow"
                @click="openDeleteModal(props.row)"
                size="sm"
                variant="danger"
              >
                <i class="fa fa-remove"></i>
              </b-button>
              <b-tooltip target="deleteRow" title="Usuń pozycję"></b-tooltip>
            </div>
          </v-server-table>
        </b-card-body>
      </b-card>
      <b-modal
        v-if="zipModal.visible"
        size="lg"
        cancel-title="Wyjdź"
        ok-title="Zatwierdź"
        title="Pobierz zestawienie"
        v-model="zipModal.visible"
        @ok="saveAsZip"
      >
        <b-form-group
          label="Dokumenty bez daty"
          label-for="zipName"
          :label-cols="3"
          :horizontal="true"
        >
          <b-input-group>
            <b-form-input
              type="text"
              :disabled="true"
              v-model="zipModal.noDateDocumentsCount"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                v-b-tooltip.hover
                title="Wyślij pozycje na swój adres email"
                @click="sendDocumentsWithoutDateLabel"
                variant="primary"
                >Wyślij</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label="Nazwa zestawienia"
          label-for="zipName"
          :label-cols="3"
          :horizontal="true"
        >
          <b-form-input
            v-validate="'required'"
            type="text"
            name="zipName"
            placeholder="Wpisz nazwę"
            v-model="zipModal.reportName"
            :class="{ 'is-invalid': errors.has('zipName') }"
          ></b-form-input>
          <div v-if="errors.has('zipName')" class="invalid-feedback">
            To pole jest wymagane
          </div>
        </b-form-group>

        <b-form-group
          label="Wyślij do"
          label-for="zipName"
          :label-cols="3"
          :horizontal="true"
        >
          <b-form-input
            type="email"
            id="email"
            placeholder="Wpisz adresy po przecinku"
            v-model="zipModal.emails"
          ></b-form-input>
        </b-form-group>
      </b-modal>
      <b-modal
        v-if="savePresetModal"
        size="lg"
        cancel-title="Wyjdź"
        ok-title="Zatwierdź"
        title="Zapisz ustawienia filtrów"
        v-model="savePresetModal"
        @ok="savePreset"
      >
        <b-form-group
          label="Nazwa konfirugarcji"
          label-for="invoice"
          :label-cols="3"
          :horizontal="true"
          v-model="document.invoice"
        >
          <b-form-input
            v-validate="'required'"
            type="text"
            name="presetName"
            placeholder="Wpisz nazwę"
            v-model="preset.name"
            :class="{ 'is-invalid': errors.has('presetName') }"
          ></b-form-input>
          <div v-if="errors.has('presetName')" class="invalid-feedback">
            To pole jest wymagane
          </div>
        </b-form-group>
      </b-modal>

      <b-modal
        size="lg"
        cancel-title="Wyjdź"
        ok-title="Zatwierdź"
        title="Usuń pozycję"
        v-model="deleteRowModal"
        @ok="deleteDocument"
      >
        <p>Czy napewno chcesz usunąć ten wiersz?</p>
      </b-modal>

      <b-modal
        size="lg"
        cancel-title="Wyjdź"
        ok-title="Zatwierdź"
        title="Edytuj pozycję"
        v-model="updateRowModal"
        @ok="updateDocument"
      >
        <b-card>
          <div slot="header">
            <strong>Formularz edycji</strong>
          </div>
          <b-form>
            <b-form-group
              v-show="document.invoiceLink.length"
              label="Linki do faktur"
              label-for="invoiceLink"
              :label-cols="3"
              :horizontal="true"
            >
              <div v-for="(link, index) in document.invoiceLink" :key="index">
                <a :href="link">Faktura {{ index + 1 }}</a>
                <i
                  @click="removeInvoice(link)"
                  style="margin-left: 15px; color: red; cursor: pointer"
                  class="fa fa-remove"
                ></i>
              </div>
            </b-form-group>
            <b-form-group
              label="Dołącz fakturę"
              label-for="invoice"
              :label-cols="3"
              :horizontal="true"
              v-model="document.invoice"
            >
              <b-form-file
                multiple
                @change="handleFilesUpload($event.target.files)"
                ref="fileinput"
                id="invoice"
              ></b-form-file>
            </b-form-group>

            <b-form-group
              label="Rodzaj dokumentu"
              label-for="documentType"
              :label-cols="3"
              :horizontal="true"
            >
              <multiselect
                deselect-label
                select-label
                placeholder="Wybierz rodzaj"
                :options="['Fizyczna', 'Online']"
                :multiple="false"
                v-model="document.docType"
              ></multiselect>
            </b-form-group>

            <b-form-group
              label="Pozycja bez faktury"
              label-for="containInvoice"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-checkbox
                :value="true"
                v-model="document.neverContainInvoice"
              ></b-form-checkbox>
            </b-form-group>

            <b-form-group
              label="Vat"
              label-for="vat"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-input
                type="number"
                placeholder="Wpisz vat"
                v-model.number="document.vat"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              description="Ręczne przypisanie etykiet"
              label="Edytuj etykiety"
              label-for="basicName"
              :label-cols="3"
              :horizontal="true"
            >
              <multiselect
                deselect-label
                select-label
                placeholder="Wybierz etykietę"
                track-by="_id"
                :options="labels"
                label="name"
                :multiple="true"
                v-model="document.labels"
              ></multiselect>
            </b-form-group>

            <b-form-group
              label="Komentarz"
              label-for="comment"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-input
                id="comment"
                :textarea="true"
                :rows="9"
                placeholder="Wpisz komentarz"
                v-model="document.comment"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Przypisz rok"
              label-for="comment"
              :label-cols="3"
              :horizontal="true"
            >
              <multiselect
                :class="{
                  'is-invalid':
                    submitted && document.invoice.length && errors.has('years'),
                }"
                v-validate="'required'"
                :name="'years'"
                :plain="true"
                :multiple="true"
                :options="availableYears"
                v-model="document.year"
              ></multiselect>
              <div
                v-if="
                  submitted && document.invoice.length && errors.has('years')
                "
                class="invalid-feedback"
              >
                To pole jest wymagane
              </div>
            </b-form-group>

            <b-form-group
              description="Zaznacz kilka wciskając shift"
              label="Przypisz miesiące"
              label-for="months"
              :label-cols="3"
              :horizontal="true"
            >
              <multiselect
                v-model="document.months"
                label="text"
                track-by="value"
                :class="{
                  'is-invalid':
                    submitted &&
                    document.invoice.length &&
                    errors.has('months'),
                }"
                v-validate="'required'"
                :name="'months'"
                :multiple="true"
                :options="availableMonths"
              >
              </multiselect>
              <div
                v-if="
                  submitted && document.invoice.length && errors.has('months')
                "
                class="invalid-feedback"
              >
                To pole jest wymagane
              </div>
            </b-form-group>
          </b-form>
        </b-card>
      </b-modal>
    </div>

    <Loading :loading="loading.processing" :text="loading.text"></Loading>
  </div>
</template>

<script>
import Vue from "vue";

import Loading from "@/components/loading.vue";

import { ClientTable, ServerTable, Event } from "vue-tables-2";
import Multiselect from "vue-multiselect";

Vue.use(ServerTable);

import { setupCalendar, DatePicker } from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";

setupCalendar({
  firstDayOfWeek: 2,
});

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn",
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};

Vue.use(VueNotifications, options);

import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

import { mapGetters, mapActions } from "vuex";

export default {
  name: "DataTable",
  components: {
    Loading,
    ServerTable,
    Event,
    "v-date-picker": DatePicker,
    Multiselect,
  },
  computed: {
    ...mapGetters("labels", {
      labels: "labels",
      filter: "filter",
    }),
    ...mapGetters("presets", {
      presets: "presets",
    }),
    ...mapGetters("documents", {
      params: "params",
    }),
    apiUrl() {
      return process.env.VUE_APP_API_URL + "/documents";
    },
  },

  methods: {
    setDateRange(value) {
      this.options.params.start = value.start;
      this.options.params.end = value.end;
      this.$refs.documentTable.refresh();
    },
    setPreset(value) {
      if (value) {
        this.options.params.filters.chargeIncome = value.chargeIncome.filter(
          (entry) => entry
        );
        this.options.params.filters.containInvoice =
          value.containInvoice.filter((entry) => entry);
        this.options.params.filters.containLabel = value.containLabel.filter(
          (entry) => entry
        );
        this.options.params.filters.excludeLabel = value.excludeLabel;
        this.options.params.filters.label = value.label;
      } else {
        this.options.params.filters.label = [];
        this.options.params.filters.chargeIncome = "";
        this.options.params.filters.containLabel = "";
        this.options.params.filters.containInvoice = "";
        this.options.params.filters.excludeLabel = [];
      }
      this.$refs.documentTable.refresh();
    },
    async saveAsZip(e) {
      e.preventDefault();

      let isValid = await this.$validator.validate();

      const isNotValid = this.errors.items.filter(
        (item) => item.field == "zipName"
      ).length;
      if (isNotValid) {
        return;
      }

      this.loading.processing = true;
      this.loading.text = "Zapis zip...";
      this.params.emails = this.zipModal.emails;
      this.params.reportName = this.zipModal.reportName;

      this.axios
        .get(process.env.VUE_APP_API_URL + "/documents/download", {
          params: this.params,
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${this.zipModal.reportName}.zip`);
          document.body.appendChild(link);
          link.click();

          this.zipModal.visible = false;
          this.loading.processing = false;
          this.loading.text = "";
          this.saveZipMsg();
        })
        .catch((error) => {
          this.zipModal.visible = false;
          this.loading.processing = false;
          this.loading.text = "";
          this.saveZipError();
        });
    },
    saveAsCsv() {
      this.loading.processing = true;
      this.loading.text = "Zapis csv...";
      this.axios
        .get(process.env.VUE_APP_API_URL + "/documents/csv", {
          params: this.params,
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "documents.csv");
          document.body.appendChild(link);
          link.click();

          this.loading.processing = false;
          this.loading.text = "";
        })
        .catch((error) => {
          this.loading.processing = false;
          this.loading.text = "";
          this.showSavePresetError();
        });
    },
    async savePreset(e) {
      e.preventDefault();

      const isValid = await this.$validator.validate();

      if (!isValid) {
        return;
      }

      const preset = {
        name: this.preset.name,
        ...this.options.params.filters,
      };

      this.loading.processing = true;
      this.loading.text = "Zapisuje preset...";

      this.axios
        .post(process.env.VUE_APP_API_URL + "/presets", { presetData: preset })
        .then((response) => {
          this.presets.push(response.data.preset);
          this.showSavePresetSuccessMsg();
          this.loading.processing = false;
          this.loading.text = "";
        })
        .catch((error) => {
          this.loading.processing = false;
          this.loading.text = "";
          this.showSavePresetError();
        });
      this.savePresetModal = false;
    },
    getLabelIds(labels) {
      return labels.map((label) => label._id);
    },
    refreshTable() {
      this.$refs.documentTable.refresh();
    },
    openDownloadZipModal() {
      this.axios
        .get(process.env.VUE_APP_API_URL + "/documents/noDate", {
          params: this.params,
        })
        .then((response) => {
          this.loading.processing = false;
          this.loading.text = "";
          this.zipModal.noDateDocumentsCount = response.data.count;
          this.zipModal.visible = true;
        })
        .catch((error) => {
          this.loading.processing = false;
          this.loading.text = "";
          this.showOpenSaveZipError();
        });
    },
    sendDocumentsWithoutDateLabel() {
      this.axios
        .get(process.env.VUE_APP_API_URL + "/documents/sendNoDate", {
          params: this.params,
        })
        .then((response) => {
          this.loading.processing = false;
          this.loading.text = "";
          this.showSendMailMsg();
        })
        .catch((error) => {
          this.loading.processing = false;
          this.loading.text = "";
          this.showSendMailError();
        });
    },
    openDeleteModal(row) {
      this.deleteRowModal = true;
      this.document.id = row._id;
    },
    openEditModal(row) {
      this.updateRowModal = true;
      setTimeout(() => this.$refs.fileinput.reset(), 0);
      this.document.id = row._id;
      this.document.vat = row.vat;
      this.document.docType = row.docType ? row.docType : "";
      this.document.invoiceLink = row.invoice;
      this.document.labels = row.labels;
      this.document.invoice = row.invoice;
      this.document.months = row.months.map((value) => {
        return this.availableMonths.find((month) => month.value === value);
      });
      this.document.comment = row.comment ? row.comment : "";
      this.document.neverContainInvoice = row.neverContainInvoice;
      this.document.year = row.year ? [row.year] : [];
    },
    handleFilesUpload(files) {
      this.document.invoice = [];
      for (var i = 0; i < files.length; i++) {
        this.document.invoice.push(files[i]);
      }
    },
    async deleteDocument(e) {
      e.preventDefault();
      this.loading.processing = true;
      this.loading.text = "Edytuje dokument...";

      this.axios
        .post(process.env.VUE_APP_API_URL + "/documents/delete", {
          id: this.document.id,
        })
        .then((res) => {
          const { page } = JSON.parse(localStorage.getItem("params"));
          this.$refs.documentTable.refresh();

          setTimeout(() => {
            this.$refs.documentTable.setPage(page);
            this.showDeleteSuccessMsg();
            this.deleteRowModal = false;
            this.loading.processing = false;
            this.loading.text = "";
          }, 100);
        })
        .catch((error) => {
          this.showDeleteError();
          this.deleteRowModal = false;
          this.loading.processing = false;
          this.loading.text = "";
        });
    },

    async removeInvoice(link) {
      const invoices = this.document.invoiceLink.filter(
        (invoiceLink) => invoiceLink !== link
      );

      this.axios
        .post(process.env.VUE_APP_API_URL + "/documents/setInvoices", {
          id: this.document.id,
          invoices,
        })
        .then((res) => {
          this.document.invoiceLink = invoices;
        })
        .catch((error) => {
          this.showError();
          this.updateRowModal = false;
          this.loading.processing = false;
          this.loading.text = "";
        });
    },

    async updateDocument(e) {
      e.preventDefault();
      this.submitted = true;
      const isValid =
        (await this.$validator.validate()) || !this.document.invoice.length;
      if (!isValid) {
        return;
      }

      let formData = new FormData();

      const labels = this.document.labels.map((label) => label._id);

      formData.append("id", this.document.id);
      formData.append("labels", JSON.stringify(labels));
      formData.append("comment", this.document.comment);
      formData.append(
        "months",
        JSON.stringify(this.document.months.map((month) => month.value))
      );
      formData.append("year", this.document.year);
      formData.append("neverContainInvoice", this.document.neverContainInvoice);
      formData.append("vat", this.document.vat);
      formData.append(
        "docType",
        this.document.docType ? this.document.docType : ""
      );

      this.document.invoice.forEach((file, index) => {
        formData.append(`invoice[${index}]`, file);
      });

      this.loading.processing = true;
      this.loading.text = "Edytuje dokument...";

      this.axios
        .post(process.env.VUE_APP_API_URL + "/documents/update", formData)
        .then((res) => {
          const { page } = JSON.parse(localStorage.getItem("params"));
          this.$refs.documentTable.refresh();

          setTimeout(() => {
            this.$refs.documentTable.setPage(page);
            this.showSuccessMsg();
            this.updateRowModal = false;
            this.loading.processing = false;
            this.loading.text = "";
          }, 100);
        })
        .catch((error) => {
          this.showError();
          this.updateRowModal = false;
          this.loading.processing = false;
          this.loading.text = "";
        });
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Sukces",
      message: "Pomyślnie zdetytowano wiersz.",
    },
    showDeleteSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Sukces",
      message: "Pomyślnie usunięto wiersz.",
    },
    showSavePresetSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Sukces",
      message: "Pomyślnie zapisano konfigurację.",
    },
    showSendMailMsg: {
      type: VueNotifications.types.success,
      title: "Sukces",
      message: "Pomyślnie wysłano email.",
    },
    saveZipMsg: {
      type: VueNotifications.types.success,
      title: "Sukces",
      message: "Pomyślnie pobrano zestawienie.",
    },
    showOpenSaveZipError: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Błąd serwera.",
    },
    showSavePresetError: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Nie udało się zapisać konfiguracji.",
    },
    showSendMailError: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Nie udało się wysłać maila.",
    },
    saveZipError: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Nie udało się pobrać zestawienia.",
    },
    showError: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Nie udało się zaimportować zestawienia.",
    },
    showDeleteError: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Nie udało się usunąć wiersza.",
    },
    filesError: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Wybierz pliki, które chcesz wczytać.",
    },
  },
  async created() {
    if (this.$route.query.documentId) {
      const documentId = this.$route.query.documentId;
      const { data } = await this.axios.get(
        `${process.env.VUE_APP_API_URL}/document?documentId=${documentId}`
      );

      if (data.document) {
        this.openEditModal(data.document);
      }
    }

    this.$store.dispatch("labels/fetchLabels");
    this.$store.dispatch("presets/fetchPresets");

    const params = localStorage.getItem("params");
    if (params) {
      this.options.params = JSON.parse(params);
      delete this.options.params.page;
      delete this.options.params.limit;
      delete this.options.params.ascending;
      delete this.options.params.byColumn;
      delete this.options.params.orderBy;
      delete this.options.params.query;
      this.datePicker.start = new Date(this.options.params.start);
      this.datePicker.end = new Date(this.options.params.end);
    }
  },
  data: function () {
    return {
      submitted: false,
      loading: {
        processing: false,
        text: "",
      },
      filterByLabels: [],
      preset: {
        name: "",
      },
      tableParams: {},
      document: {
        id: null,
        docType: null,
        vat: null,
        labels: [],
        invoice: [],
        invoiceLink: [],
        comment: "",
        neverContainInvoice: false,
        year: [],
        months: [],
      },
      columns: [
        "_id",
        "sender/recipient",
        "title",
        "account_number",
        "amount",
        "saldo",
        "operation_date",
        "accounting_date",
        "description",
        "invoice",
        "labels",
        "comment",
        "actions",
      ],
      updateRowModal: false,
      deleteRowModal: false,
      savePresetModal: false,
      zipModal: {
        visible: false,
        emails: "",
        reportName: "",
        noDateDocumentsCount: 0,
      },
      data: [],
      datePicker: {
        start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        end: new Date(),
      },
      availableYears: [
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
      ],
      availableMonths: [
        {
          text: "Styczeń",
          value: "01",
        },
        {
          text: "Luty",
          value: "02",
        },
        {
          text: "Marzec",
          value: "03",
        },
        {
          text: "Kwiecień",
          value: "04",
        },
        {
          text: "Maj",
          value: "05",
        },
        {
          text: "Czerwiec",
          value: "06",
        },
        {
          text: "Lipiec",
          value: "07",
        },
        {
          text: "Sierpień",
          value: "08",
        },
        {
          text: "Wrzesień",
          value: "09",
        },
        {
          text: "Październik",
          value: "10",
        },
        {
          text: "Listopad",
          value: "11",
        },
        {
          text: "Grudzień",
          value: "12",
        },
      ],
      options: {
        filterByColumn: true,
        params: {
          filters: {
            label: [],
            chargeIncome: "",
            containLabel: "",
            excludeLabel: [],
            containInvoice: "",
            containComment: "",
          },
          start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          end: new Date(),
        },
        columnsDropdown: true,
        columnsDisplay: {
          _id: "mobile",
          "sender/recipient": "desktop",
          title: "desktop",
          account_number: "mobile",
          amount: "desktop",
          saldo: "mobile",
          comment: "desktop",
          operation_date: "desktop",
          accounting_date: "desktop",
          description: "desktop",
          invoice: "desktop",
          actions: "desktop",
        },
        requestFunction: function (data) {
          this.$store.commit("documents/SET_PARAMS", data);
          localStorage.setItem("params", JSON.stringify(data));

          return this.axios
            .get(this.url, {
              params: data,
            })
            .catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        },
        headings: {
          "sender/recipient": "Nadawca/Odbiorca",
          title: "Tytuł",
          account_number: "Numer konta",
          amount: "Kwota",
          saldo: "Saldo",
          comment: "Komentarz",
          operation_date: "Data operacji",
          accounting_date: "Data księgowania",
          description: "Opis",
          labels: "Etykiety",
          invoice: "Faktura",
          actions: "Akcje",
        },
        sortable: [
          "sender/recipient",
          "title",
          "account_number",
          "amount",
          "saldo",
          "operation_date",
          "accounting_date",
          "description",
        ],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll",
        },
        responseAdapter: function (resp) {
          var data = resp.data;
          return { data: data.data, count: data.count };
        },
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
    };
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.date-picker {
  input {
    height: 20px;
    margin-left: 4px;
    width: 100%;
    height: 2.6rem;
  }
}
#dataTable {
  text-transform: lowercase;
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
